import { useEffect, useState } from 'react'

import {
  getPatchReceptionCallHistoryByMeetingIdMutationKey,
  useGetAttendees,
  useGetDeviceMeeting,
  usePatchReceptionCallHistoryByMeetingId,
} from '@reception-web/common/api/www'
import {
  HISTORY_CALLER_STATUS,
  HISTORY_RECEIVER_STATUS,
} from '@reception-web/common/consts'
import { useAudio } from '@reception-web/common/hooks/useAudio'
import { useTranslation } from 'react-i18next'
import { MdPhone } from 'react-icons/md'
import { Link, useNavigate } from 'react-router-dom'

import { Button, Text } from '../../components'
import { PATH } from '../../constants'
import {
  useDeviceIdProvider,
  useMeetingContext,
  useRedialApi,
} from '../../hooks'

export function CallbackFrame() {
  const { getRoute, deviceId } = useDeviceIdProvider()
  const { data: redialData } = useRedialApi(deviceId)
  const navigate = useNavigate()
  const { trigger: changeStatus } = usePatchReceptionCallHistoryByMeetingId(
    deviceId ?? '',
    redialData?.meeting_id ?? '',
    {
      swr: {
        swrKey: getPatchReceptionCallHistoryByMeetingIdMutationKey(
          deviceId ?? '',
          redialData?.meeting_id ?? ''
        )[0],
      },
    }
  )
  const { data: meetingData } = useGetDeviceMeeting(
    deviceId ?? '',
    redialData?.meeting_id ?? ''
  )
  const { data: attendeesData } = useGetAttendees(
    deviceId ?? '',
    redialData?.meeting_id ?? ''
  )
  const redialMeeting = meetingData?.data.Meeting
  // TODO: fix external id
  const redialAttendee = attendeesData?.data.Attendees?.find(
    (attendee) => attendee.ExternalUserId?.match('#')
  )
  const { meeting, attendee, setMeeting, setAttendee, setIsRedial } =
    useMeetingContext()
  const { play, stop } = useAudio({ source: '/audio/ring.mp3', repeat: true })
  const [audioPlayed, setAudioPlayed] = useState(false)
  const { i18n } = useTranslation()
  const ja = i18n.getFixedT('ja', 'translation', 'frames.CallbackFrame')
  const en = i18n.getFixedT('en', 'translation', 'frames.CallbackFrame')
  useEffect(() => {
    if (
      redialData?.call_type !== 'redial_from_reception' ||
      (redialData?.receiver_status !== null &&
        redialData?.receiver_status !== HISTORY_CALLER_STATUS.CALLING)
    ) {
      navigate(getRoute(PATH.root))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redialData])

  useEffect(() => {
    if (meeting && attendee) {
      navigate(getRoute(PATH.about))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting, attendee])

  useEffect(() => {
    if (!audioPlayed) {
      play()
      setAudioPlayed(true)
    }
  }, [play, audioPlayed])

  useEffect(
    () => () => {
      stop()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname]
  )

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-5 bg-off-white p-[60px]">
      <Text size="heading2" className="flex">
        {ja('waiting')}
        <br />
        {en('waiting')}
      </Text>
      <Button
        type="button"
        onClick={async () => {
          await changeStatus({
            receiver_status: HISTORY_RECEIVER_STATUS.RECEIVED,
            received: new Date().toISOString(),
          })
          setMeeting(redialMeeting)
          setAttendee(redialAttendee)
          setIsRedial(true)
        }}
        className="mt-12 h-[70px] w-[250px]"
        fill
      >
        <MdPhone size={24} />
        <Text size="lg3" weight="normal">
          {ja('accept')}
          <br />
          {en('accept')}
        </Text>
      </Button>
      <Link
        to={getRoute(PATH.root)}
        onClick={async (e) => {
          e.preventDefault()
          await changeStatus({
            receiver_status: HISTORY_RECEIVER_STATUS.REJECT,
            rejected: new Date().toISOString(),
          })
          // Use window.location.assign to stop ringing sound
          window.location.assign(getRoute(PATH.root))
        }}
        className="mt-10 wide:mt-6"
      >
        {ja('back')}
        <br />
        {en('back')}
      </Link>
    </div>
  )
}
